import { setSpecialtyTypesAction } from 'shared/store/data/filters/actions';
import { setTargetOffersCountTooltip } from 'shared/store/data/offersCountTooltip/actions';
import { boundActionsFactory } from 'shared/utils/hooks/useBoundActions';

export const useSpecialtyTypesFilterBoundActions = boundActionsFactory({
  setSpecialtyTypesAction,
  setTargetOffersCountTooltip,
});
